import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "list-container" }
const _hoisted_2 = { class: "terms-container" }
const _hoisted_3 = { class: "legal-protocol" }
const _hoisted_4 = {
  key: 0,
  class: "desc"
}
const _hoisted_5 = {
  key: 1,
  class: "desc-li"
}
const _hoisted_6 = {
  key: 2,
  class: "desc"
}
const _hoisted_7 = {
  key: 3,
  class: "desc-li"
}
const _hoisted_8 = {
  key: 4,
  class: "desc"
}
const _hoisted_9 = {
  key: 5,
  class: "desc-li"
}
const _hoisted_10 = {
  key: 6,
  class: "desc"
}
const _hoisted_11 = {
  key: 7,
  class: "desc-li"
}
const _hoisted_12 = {
  key: 8,
  class: "desc"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "title" }, "Permisos requeridos para utilizar Prestalight", -1)),
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "desc" }, " Para garantizar el correcto funcionamiento de nuestros servicios de préstamo y proteger tu seguridad, necesitamos acceder a ciertos permisos e información desde tu dispositivo: ", -1)),
        ($setup.showPrivacy)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _cache[1] || (_cache[1] = _createTextVNode(" Para más detalles sobre permisos y gestión de datos personales, consulta nuestra ")),
              _createElementVNode("span", {
                class: "mark-text",
                onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.viewPrivacyAgreement()))
              }, "[Política de Privacidad]"),
              _cache[2] || (_cache[2] = _createTextVNode(" . "))
            ]))
          : _createCommentVNode("", true),
        (!$setup.isIOS)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, "📍 Ubicación"))
          : _createCommentVNode("", true),
        (!$setup.isIOS)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, " Recogemos tu ubicación aproximada para evaluar riesgos relacionados con tu cuenta y mejorar la seguridad de los datos. Todas las transacciones están protegidas con cifrado SSL de 128 bits. Los datos se envían por conexión segura y se almacenan en nuestros servidores: www.prestalight.com "))
          : _createCommentVNode("", true),
        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "desc-li" }, "📷 Cámara", -1)),
        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "desc" }, " Necesitamos acceso a la cámara para facilitar la verificación de identidad (KYC). Esto te permitirá tomar fotos de tu DNI y rostro directamente desde la app. No accederemos ni almacenaremos otras fotos o vídeos de tu dispositivo. Sin tu consentimiento, no podremos completar el proceso de verificación. ", -1)),
        (!$setup.isIOS)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, "✉️ Mensajes de texto"))
          : _createCommentVNode("", true),
        (!$setup.isIOS)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, " Con tu permiso, accedemos únicamente a tus mensajes financieros (remitente, fecha y contenido). Usamos esta información para evaluar tu situación financiera, determinar si puedes obtener un préstamo y prevenir fraudes. Los mensajes se transmiten y almacenan a través de nuestros servidores seguros (https://www.prestalight.com/). Cumplimos con la normativa vigente y nuestras políticas de privacidad para proteger tus datos. No accedemos a mensajes no relacionados ni compartimos tus datos con terceros. Puedes activar o desactivar este permiso en cualquier momento desde la configuración. "))
          : _createCommentVNode("", true),
        _cache[7] || (_cache[7] = _createElementVNode("div", { class: "desc-li" }, "🔔 Notificaciones", -1)),
        _cache[8] || (_cache[8] = _createElementVNode("div", { class: "desc" }, " Con tu permiso, te enviaremos recordatorios, actualizaciones importantes y comunicaciones personalizadas. Puedes activar o desactivar esta opción cuando quieras desde la configuración. Si decides no autorizarlo, podrás seguir usando la app normalmente. ", -1)),
        (!$setup.isIOS)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, "📱 Aplicaciones instaladas"))
          : _createCommentVNode("", true),
        (!$setup.isIOS)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, " Recopilamos únicamente información básica de ciertas apps instaladas (nombre, versión, fecha de instalación/actualización, si son del sistema), con el fin de prevenir fraudes y proteger la seguridad financiera de tu cuenta. "))
          : _createCommentVNode("", true),
        _cache[9] || (_cache[9] = _createStaticVNode("<div class=\"space-400\" data-v-0fb15460></div><div class=\"subtitle\" data-v-0fb15460>Permisos estándar del sistema</div><div class=\"space-400\" data-v-0fb15460></div><div class=\"desc-li\" data-v-0fb15460>📶 Estado del WiFi</div><div class=\"desc\" data-v-0fb15460> Usamos esta información para evaluar riesgos y detectar posibles anomalías en la red. </div><div class=\"desc-li\" data-v-0fb15460>🌐 Estado de red</div><div class=\"desc\" data-v-0fb15460> Nos permite conocer el tipo de conexión y estado de red para evitar pérdida de datos o retrasos causados por problemas de conectividad. </div>", 7)),
        (!$setup.isIOS)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, "📊 Identificador publicitario (ADID)"))
          : _createCommentVNode("", true),
        (!$setup.isIOS)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, " Recolectamos tu ID publicitario de Google (GAID) para analizar resultados de campañas y mejorar tu experiencia publicitaria. Puedes desactivar esta opción desde la configuración de tu dispositivo. "))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}